import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '@/organisms/Tooltip';

const RailButton = ({ icon: Icon, name, active = true, command, onSelect, hoverText }) => {
    const handleClick = useCallback(() => {
        if (!command) return;
        onSelect?.(command);
    }, [command, onSelect]);
    const [hovered, setHovered] = useState(false);

    const isActiveOrHover = active || hovered;
    return (
        <Tooltip content={hoverText || name} placement="right" verticalOffset={0}>

            <div
                onClick={handleClick}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                className={classNames(
                    "flex items-center gap-1.5 px-2 py-1.5 cursor-pointer rounded transition-all border border-transparent w-full",
                    {
                        "text-success-500 !border-success-500 ": isActiveOrHover,
                        "text-gray-100 hover:text-success-500 ": !active,
                    }
                )}
            >
                {/* ICON */}
                <Icon
                    className={classNames("transition-colors w-4 h-4", {
                        "text-success-500": isActiveOrHover,
                        "text-gray-100 group-hover:text-success-500": !active,
                    })}
                />

                {/* TEXT */}
                <span style={{
                    color: isActiveOrHover ? active : "#d1d4dc",
                }} className="text-xs font-semibold">{name}</span>
            </div>
        </Tooltip>
    );
};

const SidebarSection = ({ title, items, active, onSelect }) => {
    return (
        <div>
            <div className="text-gray-200 text-[10px] font-medium pt-2 pb-2.5 border-t border-gray-600">{title}</div>

            <div className="flex flex-col gap-2.5">
                {items.map((item) => (
                    <RailButton
                        key={item.id}
                        icon={item.icon}
                        name={item.name}
                        command={item.command}
                        active={active === String(item.command || '').toUpperCase()}  // ✅ FIX
                        onSelect={onSelect}
                        hoverText={item.hoverText}
                    />
                ))}
            </div>
        </div>
    );
};
export default SidebarSection;
